<template>
  <div class="teen-page teen3">
    <div class="header">
      <h1>长江：中华民族的母亲河</h1>
    </div>

    <div class="container">
      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/changjiang.svg" alt="长江三峡">
        <div class="caption">长江三峡，壮丽的自然景观</div>
      </div>

      <h2>一、 长江概况</h2>
      <p>长江是中国第一大河，也是世界第三长河，全长约6300公里。它发源于青藏高原的唐古拉山脉，流经11个省市自治区，最终注入东海。长江流域面积广阔，水资源丰富，是中华民族的母亲河。</p>

      <h2>二、 源头探秘</h2>
      <p>长江的源头位于青海省南部的唐古拉山脉主峰各拉丹冬雪山。这里冰川广布，冰雪融化形成了长江的最初水流。长江源区生态环境脆弱而美丽，是众多珍稀动物的栖息地。</p>

      <div class="img-box">
        <img src="https://img.moliaos.com/v/teen/changjiang.svg" alt="长江源头">
        <div class="caption">长江源头，冰雪皑皑的青藏高原</div>
      </div>

      <h2>三、 三峡奇观</h2>
      <p>长江三峡是长江上最壮丽的一段，包括瞿塘峡、巫峡和西陵峡。两岸奇峰耸立，江水奔腾，景色壮观。三峡工程是世界上最大的水利枢纽工程，具有防洪、发电、航运等综合效益。</p>

      <h2>四、 长江三角洲</h2>
      <p>长江入海口形成了肥沃的长江三角洲平原。这里是中国经济最发达的地区之一，上海、南京、杭州等大城市坐落于此。长江三角洲也是中国重要的农业基地和工业中心。</p>

      <div class="quote-box">
        "你从雪山走来，春潮是你的风采；你向东海奔去，惊涛是你的气概。" —— 《长江之歌》
      </div>

      <h2>五、 保护母亲河</h2>
      <p>长江是中华民族的生命线，但近年来也面临着污染、生态破坏等问题。保护长江生态环境，实现可持续发展，是我们每个人的责任。让我们共同守护这条伟大的河流。</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Teen3'
}
</script>

<style scoped>
.teen-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  margin: 0;
  background: #e8f4fc;
  line-height: 1.8;
}

.header {
  background: linear-gradient(135deg, #006994 0%, #0088aa 100%);
  color: white;
  padding: 30px 20px;
  text-align: center;
}

.container {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;
}

h1 {
  margin: 0;
  font-size: 1.6rem;
}

h2 {
  color: #006994;
  border-bottom: 2px solid #4db6ac;
  padding-bottom: 8px;
  margin-top: 30px;
  font-size: 1.2rem;
}

p {
  text-indent: 2em;
  margin-bottom: 20px;
  text-align: justify;
}

.img-box {
  text-align: center;
  margin: 25px 0;
}

.img-box img {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 10px rgba(0,0,0,0.1);
}

.caption {
  font-size: 0.85rem;
  color: #666;
  margin-top: 10px;
}

.quote-box {
  background: #e1f5fe;
  padding: 20px;
  border-left: 4px solid #006994;
  margin: 25px 0;
  font-style: italic;
  color: #333;
}
</style>